import * as _actions from './actions';
import _reducer from './reducer';

export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/ProgressTests/ViewLink/index.js